
import { XIcon, CheckIcon } from "@heroicons/react/solid";
import DataGrid, { Paging, Pager, Column, Scrolling, RemoteOperations } from 'devextreme-react/data-grid';
import { useTranslation } from 'react-i18next'

const TableUpload = (props) => {
  const { t } = useTranslation(['uploadjob', 'common'])
  let { dataSource, pageSize = 50 } = props // STATE
  let { setOpenEditQueue, onDelete } = props // ACTION

  return (
    <DataGrid
      dataSource={dataSource}
      keyExpr="id"
      height={'calc(100vh - 230px)'}
      showBorders={true}
      allowColumnReordering={true}
      columnAutoWidth={true}
      columnMinWidth={100}
      hoverStateEnabled={true}
      remoteOperations={{ paging: true }}
      onRowPrepared={(e: any) => {
        if (e.rowType === "data" && e.data.valid_message !== "") {
          e.rowElement.style.backgroundColor = "#ffbdbd"
        }
      }}
    >
      <Scrolling columnRenderingMode="virtual" />
      <RemoteOperations paging={true} />
      <Paging enabled={true} defaultPageSize={pageSize} />
      <Pager
        visible={true}
        showInfo={true}
        showNavigationButtons={true}
        showPageSizeSelector={true}
        allowedPageSizes={[20, 50, 100]}
        displayMode="full"
      />
      <Column dataField="no" caption={t('no')} />
      <Column dataField="po_no" caption="PO No." />
      <Column dataField="gq_no" caption="D/O No." />
      <Column dataField="cust_code" caption={t('customer_code')} />
      <Column dataField="cust_name" caption={t('customer_name')} />
      <Column dataField="loc_receipt_name" caption={t('origin')} />
      <Column dataField="loc_dest_name" caption={t('destination')} />
      <Column dataField="job_type_name" caption={t('job_type')} />
      <Column dataField="logistic_type_name" caption={t('shipment_type')} />
      <Column dataField="delivery_date" caption={t('delivery_date')} />
      <Column dataField="qno" caption={t('order_no')} />
      <Column dataField="job_date" caption={t('date_received')} />
      <Column dataField="center_name" caption={t('department')} />
      <Column dataField="shipment_type_name" caption={t('trip_type')} />
      <Column dataField="product_code" caption={t('product_code')} />
      <Column dataField="product_name" caption={t('product_name')} />
      <Column dataField="ref_order_no" caption="Ref Order No" />
      <Column dataField="track_no" caption="Track No" />
      <Column dataField="total_qty" caption={t('quantity')} />
      <Column dataField="unit_name" caption={t('unit')} />
      <Column dataField="valid_message" caption={t('error')} />
      <Column
        fixed={true}
        fixedPosition="right"
        alignment="center"
        width={80}
        dataField="valid_message"
        caption={t('validate')}
        cellRender={(e) => {
          return <div className="flex justify-center">
            {e.value === "" ? <CheckIcon className="w-5 h-5 text-success-500" /> : <XIcon className="w-5 h-5 text-danger-500" />}
          </div>
        }}
      />
      <Column
        fixed={true}
        type="buttons"
        width={80}
        buttons={[
          {
            hint: t('common:edit'),
            icon: "fa fa-pencil-square-o",
            visible: true,
            onClick: (e) => {
              e.cancel = "true"
              setOpenEditQueue(e.row.data)
            }
          },
          {
            hint: t('common:delete'),
            icon: "trash",
            visible: true,
            onClick: (e) => {
              e.cancel = "true"
              onDelete(e.row.data.id)
            }
          }
        ]} />
    </DataGrid>
  )
}

export default TableUpload